import React, { useState, useEffect } from 'react'
import getImage from 'common/getImage'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import { request } from 'meinian-package/src/utils'
import { message } from 'antd'
import NoteList from '../../annotate/noteList'
import styles from './index.module.less'

export default ({
  setIsAnnotate,
  isAnnotate,
  notes,
  setNotes,
  setActiveNoteIndex,
  isMove,
  loginUserInfo,
  currentImage,
}) => {
  const [originImage, setOriginImage] = useState<any>()
  console.log(currentImage, 'currentImage')

  useEffect(() => {
    getImage(currentImage.mainUrl).then((img) => {
      setOriginImage({
        width: img.naturalWidth,
        height: img.naturalHeight,
      })
    }).catch(() => {
      setOriginImage({
        width: currentImage?.width,
        height: currentImage?.height,
      })
    })
  }, [currentImage])

  return <div className={styles.annotationInfo}>
    <div className={styles.titleLine}>
      <div className={styles.point} />
      <div className={styles.mainTitle}>
        批注 <span style={{
        marginLeft: '8px',
        fontWeight: '600',
        color: 'var(--m-text-3)' }}
        >{notes.length}</span>
      </div>
    </div>
    <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Button
        active={isAnnotate}
        onClick={() => {
          setIsAnnotate(!isAnnotate)
        }}
      >
        <Icon type="m-tianjia_miaobian" style={{ marginRight: '8px' }} />新增批注
      </Button>
      <Button
        type="normal"
        onClick={async () => {
          try {
            // 批注导出
            await request.post('/zhikuan/annotation/export-blog-annotation', {
              mainUrl: currentImage.mainUrl,
              targetId: currentImage.collectId,
              pageUrl: location.href
            })
            message.success('导出成功，可在数据导出列表下载')
          } catch (error) {
            message.error('导出失败，请重试')
          }
        }}
      >导出</Button>
    </div>
    <div className="note-list-container">
      <NoteList
        originImage={originImage}
        mainUrl={currentImage.mainUrl}
        notes={notes}
        setNotes={setNotes}
        setIsAnnotate={setIsAnnotate}
        setActiveNoteIndex={setActiveNoteIndex}
        isAnnotate={isAnnotate}
        isMove={isMove}
        loginUserInfo={loginUserInfo}
        _onChange={undefined}
      />
    </div>
  </div>
}
